import { Component } from '@angular/core';
import { ActivatedRoute, Params, Router, RouterModule, RouterOutlet } from '@angular/router';
import { GUEST_CART_ID, GUEST_ID, REGISTRATION_COMPLETE, TOKEN, USER_ID } from './constants/constant';
import { Subject, takeUntil } from 'rxjs';
import { StateService } from './service/state.service';
import { GuestService } from './service/guest.service';
import { SignInModalService } from './service/sign-in-modal.service';
import { StorageService } from './service/storage.service';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';

@Component({
  selector: 'app-root',
  imports: [
    RouterModule,
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  unsubscribe$ = new Subject();

  cartCount: number = 0;

  constructor(
    private stateService: StateService,
    private guestService: GuestService,
    private localStorageService: StorageService,
    public route: Router,
    private signInModal: SignInModalService,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {

    this.stateService.guestUser$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        this.loadGuestDetails();
      });

    const checkToken = this.localStorageService.getItem(TOKEN);
    if (
      checkToken == null ||
      this.isTokenExpired(checkToken) ||
      !this.checkRoleId(checkToken)
    ) {
      this.localStorageService.removeItem(TOKEN);
      this.localStorageService.removeItem(REGISTRATION_COMPLETE);
      this.localStorageService.removeItem(USER_ID);
      this.stateService.reloadGuestUser(true);
    } else {
      this.stateService.isTokenFetch(true);
    }

    this.activatedRoute.queryParams.subscribe(params => {
      if (params['signIn'] && !this.localStorageService.getItem(TOKEN)) {
        this.signInModal.open(params['checkout'])
      }
      // else {
      //   const queryParams: Params = { signIn: null, checkout: null };
      //   this.route.navigate([], {
      //     relativeTo: this.activatedRoute,
      //     queryParams: queryParams,
      //     queryParamsHandling: 'merge',
      //   });
      // }
    });
  }

  hideMenu() {
    this.stateService.setIsMenuOpen(false)
  }

  private isTokenExpired(token: string) {
    const expiry = JSON.parse(atob(token.split('.')[1])).exp;
    return 1000 * expiry - new Date().getTime() < 5000;
  }

  private checkRoleId(token: string) {
    return JSON.parse(atob(token.split('.')[1])).RoleID === '1';
  }

  private loadGuestDetails() {
    if (
      !this.localStorageService.getItem(GUEST_ID) &&
      !this.localStorageService.getItem(GUEST_CART_ID) &&
      !this.localStorageService.getItem(TOKEN)
    ) {
      this.localStorageService.removeItem(TOKEN);
      this.guestService
        .getGuestDetails()
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((res) => {
          this.localStorageService.setItem(GUEST_ID, res.data.guestId);
          this.localStorageService.setItem(GUEST_CART_ID, res.data.guestCId);
          this.stateService.isGuestUserFetch(true);
        });
    } else {
      this.stateService.isGuestUserFetch(true);
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }
}
